import React, { useEffect, useState } from "react";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import BookmarkBorderOutlinedIcon from "@mui/icons-material/BookmarkBorderOutlined";
import CreateOutlinedIcon from "@mui/icons-material/CreateOutlined";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import { useLocation, useNavigate } from "react-router-dom";
import { BottomNavigation, BottomNavigationAction, Paper } from "@mui/material";
import Cookies from "js-cookie";
import { profileCheckingApi } from "../../providers/userProvider";

const BottomNavbar = (props) => {
  const tab = Cookies.get("selectedTab");
  const token = Cookies.get("jwtToken");
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedTab, setSelectedTab] = useState(tab || "home");
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const loadProfile = async () => {
      if (!token) {
        setIsAdmin(false);
        return;
      }

      const response = await profileCheckingApi();
      setIsAdmin(!!response?.data?.res?.admin);
    };

    loadProfile();
  }, [token]);

  useEffect(() => {
    const pathname = location.pathname || "/";

    if (pathname === "/") {
      setSelectedTab("home");
      return;
    }

    if (pathname.startsWith("/createblog")) {
      setSelectedTab("createblog");
      return;
    }

    if (pathname.startsWith("/admin")) {
      setSelectedTab("admin");
      return;
    }

    if (pathname.startsWith("/user/saved")) {
      setSelectedTab("saved");
      return;
    }
  }, [location.pathname]);

  const handleChange = (path) => {
    Cookies.set("selectedTab", path);
    setSelectedTab(path);
    navigate(
      path === "createblog"
        ? "/createblog"
        : path === "admin"
          ? "/admin"
        : path === "home"
          ? "/"
          : `/user/${path}`,
    );
  };
  return (
    <Paper
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        display: { xs: "block", md: "none" },
        background: "var(--home-card-bg)",
        backdropFilter: "blur(18px)",
        borderTop: "1px solid var(--home-border)",
        boxShadow: "var(--home-glass-shadow)",
      }}
      elevation={3}
    >
      <BottomNavigation
        value={selectedTab}
        sx={{
          background: "transparent",
          "& .MuiBottomNavigationAction-root": {
            color: "var(--home-muted)",
            minWidth: 0,
          },
          "& .Mui-selected": {
            color: "var(--home-accent)",
          },
        }}
      >
        <BottomNavigationAction
          label="Home"
          value="home"
          icon={<HomeOutlinedIcon />}
          onClick={(e) => handleChange("home")}
        />
        {token && (
          <BottomNavigationAction
            label="Create"
            value="createblog"
            icon={<CreateOutlinedIcon />}
            onClick={(e) => handleChange("createblog")}
          />
        )}
        {token && isAdmin && (
          <BottomNavigationAction
            label="Admin"
            value="admin"
            icon={<ShieldOutlinedIcon />}
            onClick={() => handleChange("admin")}
          />
        )}
        <BottomNavigationAction
          label="Saved"
          value="saved"
          icon={<BookmarkBorderOutlinedIcon />}
          onClick={(e) => handleChange("saved")}
        />
      </BottomNavigation>
    </Paper>
  );
};

export default BottomNavbar;
